import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ManualNotaxinvoicePageRoutingModule } from "./manual-notaxinvoice-routing.module";

import { ManualNotaxinvoicePage } from "./manual-notaxinvoice.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualNotaxinvoicePageRoutingModule,
  ],
  declarations: [ManualNotaxinvoicePage],
  exports: [ManualNotaxinvoicePage],
})
export class ManualNotaxinvoicePageModule {}
